var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-search"},[_c('v-input-search',{staticClass:"main-search__input",attrs:{"placeholder":"Введите слово для поиска"},on:{"closeHeaderSearch":function($event){return _vm.$emit('closeHeaderSearch')},"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }